module.exports = function () {
    var userAgent = ICF.Utils.GetUserAgent();
    return /android/.test(userAgent) && /mobile/.test(userAgent);
};